import { render } from "./base-switch.vue?vue&type=template&id=538e0b90&ts=true"
import script from "./base-switch.vue?vue&type=script&lang=ts"
export * from "./base-switch.vue?vue&type=script&lang=ts"

import "./base-switch.vue?vue&type=style&index=0&id=538e0b90&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__